import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import Dialog from 'material-ui/Dialog';
import Snackbar from 'material-ui/Snackbar';
import Chip from 'material-ui/Chip';
import { List, ListItem } from 'material-ui/List';
import FlatButton from 'material-ui/FlatButton';
import Moment from 'react-moment';
import { withRouter } from 'react-router-dom';
import AmCharts from "@amcharts/amcharts3-react";

import Loading from '../../components/Loading';
import getNumberStyle from '../../utils';
import { callSelected } from './conferenceDetailActions';
import API from '../../api/ApiTool';

const styles = {
  flex: {
    display: 'flex',
    height: '30px'
  },
  actions: {
    cursor: 'pointer',
    color: '#3b82f6'
  }
};

const ConferenceDetailTable = (props) => {
  return (
    <Table selectable={false}>
      <TableHeader>
        <TableRow>
          <TableHeaderColumn>Number</TableHeaderColumn>
          <TableHeaderColumn>Call Sid</TableHeaderColumn>
          <TableHeaderColumn>Joined at</TableHeaderColumn>
          <TableHeaderColumn>DB Status</TableHeaderColumn>
          <TableHeaderColumn>Left</TableHeaderColumn>
          <TableHeaderColumn>Actions</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody>
        {props.data.conference_calls.map((call, i) =>
          <TableRow key={i}>            
            <TableRowColumn>{call.source}</TableRowColumn>
            <TableRowColumn>{call.sid}</TableRowColumn>
            <TableRowColumn>
              <Moment format="YYYY/MM/DD HH:mm">
                {call.created}
              </Moment>
            </TableRowColumn>
            <TableRowColumn>{call.status}</TableRowColumn>
            <TableRowColumn>
              <Moment format="YYYY/MM/DD HH:mm">
                {call.updated}
              </Moment>
            </TableRowColumn>
            <TableRowColumn>
              <a style={styles.actions} onClick={() => {
                props.alertHandleOpen('closeCall');
                props.callSelected(call.id);
              }}>
                {'CloseDB '}
              </a>
              <a style={styles.actions} onClick={() => {
                props.alertHandleOpen('hangupCall');
                props.callSelected(call.id);
              }}>
                {'Hangup'}
              </a>
            </TableRowColumn>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}

class ConferenceDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      events: {},
      closeCallAlertOpen: false,
      closeConferenceAlertOpen: false,
      hangupAlertOpen: false,
      notificationOpen: false,
      notificationText: ''
    };
  }

  componentDidMount() {
    const conferenceId = this.props.id || this.props.match.params.id;    

    API.GET(`/bridges/conferences/${conferenceId}/`)
      .then(response => response.json())
      .then(data => this.setState({ data: data }));

    API.GET(`/bridges/conference-events/?id=${conferenceId}`)
      .then(response => response.json())
      .then(data => this.setState({ events: data }));
  }

  alertHandleOpen = (actionType) => {
    if (actionType === 'closeCall') {
      this.setState({ closeCallAlertOpen: true });
    }
    else if (actionType === 'closeConference') {
      this.setState({ closeConferenceAlertOpen: true });
    }
    else {
      this.setState({ hangupAlertOpen: true });
    }
    this.setState({ notificationOpen: false });
    this.setState({ notificationText: '' });
  };

  alertHandleClose = (actionType) => {
    if (actionType === 'closeCall') {
      this.setState({ closeCallAlertOpen: false });
    }
    else if (actionType === 'closeConference') {
      this.setState({ closeConferenceAlertOpen: false });
    }
    else {
      this.setState({ hangupAlertOpen: false });
    }
  };

  handleSubmit = (actionType) => {
    const conferenceId = this.props.id || this.props.match.params.id;    

    if (actionType === 'closeCall') {
      API.POST(`/bridges/close-call/`, {'id': this.props.selectedID})
        .then(response => response.json())
        .then(data => {
          if (data.status === 200) {
            this.setState({ closeCallAlertOpen: false });
            this.setState({ notificationOpen: true });
            this.setState({ notificationText: 'Call closed successfully' });
            API.GET(`/bridges/conferences/${conferenceId}/`)
              .then(response => response.json())
              .then(data => this.setState({ data: data }))
              this.setState({ notificationOpen: false });
          }
        })
        .catch(() => {
          this.setState({ notificationOpen: true });
          this.setState({
            notificationText: 'The server encountered an error. Please try again later'
          });
        });
    }
    else if (actionType === 'closeConference') {
      API.POST(`/bridges/close-conference/`, {'id': conferenceId})
        .then(response => response.json())
        .then(data => {
          if (data.status === 200) {
            this.setState({ closeConferenceAlertOpen: false });
            this.setState({ notificationOpen: true });
            this.setState({ notificationText: 'Conference closed successfully' });
            API.GET(`/bridges/conferences/${conferenceId}/`)
              .then(response => response.json())
              .then(data => this.setState({ data: data }))
              this.setState({ notificationOpen: false });
          }
        })
        .catch(() => {
          this.setState({ notificationOpen: true });
          this.setState({
            notificationText: 'The server encountered an error. Please try again later'
          });
        });
    }
    else {
      API.POST(`/bridges/hangup-call/`, {'id': this.props.selectedID })
        .then(response => response.json())
        .then(data => {
          if (data.status === 200) {
            this.setState({ hangupAlertOpen: false });
            this.setState({ notificationOpen: true });
            this.setState({ notificationText: 'Hangup call successfully' });
            API.GET(`/bridges/conferences/${conferenceId}/`)            
              .then(response => response.json())
              .then(data => this.setState({ data: data }))
              this.setState({ notificationOpen: false });
          }
        })
        .catch(() => {
          this.setState({ notificationOpen: true });
          this.setState({
            notificationText: 'The server encountered an error. Please try again later'
          });
        });
    }
  }

  render() {
    const { data, closeCallAlertOpen, closeConferenceAlertOpen, hangupAlertOpen,
      notificationOpen, notificationText, events } = this.state;

    const conferenceId = this.props.id || this.props.match.params.id
    let config = {};

    const closeCallactions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={() => this.alertHandleClose('closeCall')}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={() => this.handleSubmit('closeCall')}
      />,
    ];

    const closeConferenceActions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={() => this.alertHandleClose('closeConference')}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={() => this.handleSubmit('closeConference')}
      />,
    ];

    const hangupActions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={() => this.alertHandleClose('hangupCall')}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={() => this.handleSubmit('hangupCall')}
      />,
    ];

    if (Object.keys(data).length === 0 || Object.keys(events).length === 0) {
      return (
        <Loading left={this.props.left} />
      );
    }

    config = {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "dataDateFormat": "YYYY-MM-DD HH:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date"
      },
      "brightnessStep": 7,
      "graph": {
        "lineAlpha": 1,
        "lineColor": "#fff",
        "fillAlphas": 0.85,
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDateField": "start",
      "endDateField": "end",
      "dataProvider": events.data,
      "valueScrollbar": {
        "autoGridCount": true
      },
      "chartCursor": {
        "cursorColor": "#55bb76",
        "valueBalloonsEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable": false,
        "valueZoomable": true
      },
      "export": {
        "enabled": true
      }
    }

    return (
      <div>
        <Snackbar
          open={notificationOpen}
          message={notificationText}
          autoHideDuration={4000}
        />
        <Dialog
          title="Close call DB"
          actions={closeCallactions}
          modal={false}
          open={closeCallAlertOpen}
          onRequestClose={() => this.alertHandleClose('closeCall')}
        >
          {'You are going to force the DB to close a call. Proceed?'}
        </Dialog>
        <Dialog
          title="Hangup Call"
          actions={hangupActions}
          modal={false}
          open={hangupAlertOpen}
          onRequestClose={() => this.alertHandleClose('hangupCall')}
        >
          {'You are going to hangup a call. Proceed?'}
        </Dialog>
        <Dialog
          title="Close conference DB"
          actions={closeConferenceActions}
          modal={false}
          open={closeConferenceAlertOpen}
          onRequestClose={() => this.alertHandleClose('closeConference')}
        >
          {'You are going to force the DB to close a conference. Proceed?'}
        </Dialog>
        <h1 style={{color: '#e5e7eb', fontFamily: '"Inter", system-ui, sans-serif'}}>
          Conference detail
        </h1>
        <List>
          <ListItem primaryText="Company "
            secondaryText={data.bridge.company.name} />
          <ListItem primaryText="Number "
            secondaryText={
              <div style={styles.flex}>
                <div style={{marginTop: '8px', marginRight: '4px'}}>
                  {data.bridge.bridge_number}
                </div>
                <Chip style={getNumberStyle(data.bridge.service_provider)}>
                  {data.bridge.service_provider} - {data.bridge.billing_provider}
                </Chip>
              </div>
            } />
          <ListItem primaryText="Started At "
            secondaryText={<Moment format="YYYY/MM/DD HH:mm">{data.created}</Moment>} />
          <ListItem primaryText="Minutes "
              secondaryText={data.minutes_used} />
          <ListItem primaryText="Status "
            secondaryText={
              <div>
                <span>{`${data.status} `}</span>
                <span>{`- `}</span>
                <span>
                  <a style={styles.actions}
                    onClick={() => this.alertHandleOpen('closeConference')}>
                    Close conference DB
                  </a>
                </span>
                <span>{` - `}</span>
                <span>
                  <a style={styles.actions}
                    onClick={() => this.props.history.push('/conference-geolocation/' + conferenceId)}>
                    Geolocation
                  </a>
                </span>
                <span>{` - `}</span>
                <span>
                  <a style={styles.actions}
                    onClick={() => this.props.history.push('/pull-streams/' + conferenceId)}>
                    Pull Streams 
                  </a>
                </span>
              </div>
            } />
          <ListItem primaryText="Total callers "
            secondaryText={data.conference_calls.length} />

          
        </List>
        <ConferenceDetailTable
          data={data}
          alertHandleOpen={this.alertHandleOpen}
          callSelected={this.props.callSelected} />
        <br/>
        <h4 style={{color: '#94a3b8', fontFamily: '"Inter", system-ui, sans-serif'}}>Floor speaker event report</h4>
        <AmCharts.React style={{ width: "100%", height: "500px", marginTop: "20px" }} options={config} />
      </div>
    );
  }
}

const mapStateToProps = state => ({ selectedID: state.conferenceDetail });

const enhance = connect(mapStateToProps, {
  callSelected: callSelected
})(ConferenceDetail);

export default withRouter(enhance);



// WEBPACK FOOTER //
// ./src/pages/ConferenceDetail/index.js